import ChallengeManagerStats from './ChallengeManagerStats';
import IntraChallengeIdeasStats from './IntraChallengeIdeasStats';
import IntraChallengesByTopicStats from './IntraChallengesByTopicStats';
import TotalIntraChallengeStats from './TotalIntraChallengeStats';

function IntraChallengesGraphs() {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <TotalIntraChallengeStats />
      <IntraChallengesByTopicStats />
      <IntraChallengeIdeasStats className="col-span-2" />
      <ChallengeManagerStats />
    </div>
  );
}

export default IntraChallengesGraphs;
